import * as React from 'react';
import { Box, Skeleton } from '@mui/material';
import Dashboard from '../dashboard';
import { useTags } from '../../hooks/useTags';
import { VIDEO_LEFT_COLUMN_WIDTH_KEY } from '../../constants/tags';

const VideoSkeleton: React.FC = () => {
  const { getTag } = useTags();
  const leftColumnWidth = React.useMemo(() => {
    const savedWidth = getTag(VIDEO_LEFT_COLUMN_WIDTH_KEY);
    return savedWidth ? parseFloat(savedWidth) : 66;
  }, [getTag]);

  return (
    <Dashboard>
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', lg: 'row' },
          height: { xs: 'auto', lg: 'calc(100vh - 66px)' },
        }}
      >
        <Box
          sx={{
            width: { xs: '100%', lg: `${leftColumnWidth}%` },
            height: { xs: 'auto', lg: '100%' },
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Box sx={{ flex: 1, overflowY: 'auto', p: 2, pr: { xs: 2, lg: 0 } }}>
            <Box sx={{ position: 'relative', width: '100%', pt: '56.25%' }}>
              <Skeleton
                variant="rectangular"
                sx={{
                  borderRadius: 1,
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                }}
              />
            </Box>
            <Skeleton
              variant="rectangular"
              height={12}
              sx={{ mt: 1.5, borderRadius: 1 }}
            />
            <Skeleton
              variant="rectangular"
              height={12}
              sx={{ mt: 1.5, borderRadius: 1 }}
            />
            <Skeleton
              variant="rectangular"
              height={12}
              sx={{ mt: 1.5, borderRadius: 1 }}
            />
          </Box>
        </Box>
        <Box
          sx={{
            width: { xs: '100%', lg: '4px' },
            height: { xs: '4px', lg: 'auto' },
            backgroundColor: 'transparent',
          }}
        />
        <Box
          sx={{
            width: {
              xs: '100%',
              lg: `calc(${100 - leftColumnWidth}% - 4px)`,
            },
            height: { xs: 'auto', lg: '100%' },
            overflow: 'hidden',
            p: 2,
          }}
        >
          {/* Empty on mobile, will show content on desktop */}
        </Box>
      </Box>
    </Dashboard>
  );
};

export default VideoSkeleton;
